export class SetPuzzleID {
  static readonly type = '[PuzzleID] Set puzzleID';
  constructor(public payload: { puzzleID: string }) {}
}

export class ResetPuzzleID {
  static readonly type = '[PuzzleID] Reset puzzleID';
  constructor() {}
}
